import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import {
  ButtonComponent,
  FormComponents,
  BreadcrumbComponent,
  BreadcrumbItemComponent,
  PressEnterDirective,
} from '@triple/triad';

import { IdpConfigToken } from '@idp/features/config';
import { IdpBoxComponent } from '@idp/shared/components/box/box.component';
import { IdpPageContainerComponent } from '@idp/shared/components/page-container/page-container.component';

import { AuthUsecaseService } from '../../services/auth-usecase.service';

@Component({
  selector: 'page-password-reset',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    ButtonComponent,
    FormComponents,
    BreadcrumbComponent,
    BreadcrumbItemComponent,
    IdpPageContainerComponent,
    IdpBoxComponent,
    PressEnterDirective,
  ],
  templateUrl: './password-reset.page.html',
  styleUrls: ['./password-reset.page.scss'],
})
export class PasswordResetPage {
  emailForm = new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email] });

  private readonly idpConfig = inject(IdpConfigToken);
  private readonly authUsecase = inject(AuthUsecaseService);

  get authEmailDomain() {
    return `@${this.idpConfig.authEmailDomain}`;
  }

  async submit() {
    await this.authUsecase.resetPassword(this.emailForm.value);
  }
}
